export { moneyFormatter } from './moneyFormatter';
export { numberFormatter } from './numberFormatter';
export * from './types';
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlscy9mb3JtYXR0ZXJzL2luZGV4LnRzIl0sIm5hbWVzIjpbIm1vbmV5Rm9ybWF0dGVyIiwibnVtYmVyRm9ybWF0dGVyIl0sIm1hcHBpbmdzIjoiQUFBQSxTQUFTQSxjQUFULFFBQStCLGtCQUEvQjtBQUNBLFNBQVNDLGVBQVQsUUFBZ0MsbUJBQWhDO0FBQ0EsY0FBYyxTQUFkIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgbW9uZXlGb3JtYXR0ZXIgfSBmcm9tICcuL21vbmV5Rm9ybWF0dGVyJztcbmV4cG9ydCB7IG51bWJlckZvcm1hdHRlciB9IGZyb20gJy4vbnVtYmVyRm9ybWF0dGVyJztcbmV4cG9ydCAqIGZyb20gJy4vdHlwZXMnO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/formatters/index.js
// module id = 1735
// module chunks = 118